/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

/* Configuration options for message dialogs */
import {TemplateRef} from '@angular/core';
import {MatDialogConfig} from '@angular/material/dialog';
import {Subject} from 'rxjs';

export namespace RSDialog {
    export enum Type {
        CONFIRM = 'CONFIRM',
        PROMPT = 'PROMPT',
        INPUT = 'INPUT' // TODO: IMPLEMENT
    }
    export enum Style {
        NORMAL, ERROR, WARN, SUCCESS
    }
    export enum InputType {
        TEXT = 'TEXT',
        PASSWORD = 'PASSWORD',
        NUMBER = 'NUMBER',
        TEXTAREA = 'TEXTAREA',
        SELECT = 'SELECT' // TODO:
    }
    export class Button {
        title: string;
        icon: string;
        value: any;
        style: RSDialog.Style | null;
        constructor(title: string, icon: string, value: any, style: RSDialog.Style | null = null) {
            this.title = title;
            this.icon = icon;
            this.value = value;
            this.style = style || null;
        }
    }

    export interface DialogHandles {
        close: (value?: any) => {};
        buttonTemplateAttach: () => {};
        buttonTemplateRef: TemplateRef<any>;
        onScroll: Subject<Event>;
    }

    export enum ButtonTypes {
        YES, NO, CANCEL, OKAY
    }
    export const defaultValues = { // TODO: MAKE THIS A CONFIG SETTING
        YES: true,
        NO: false,
        CANCEL: -1,
    };
    export class Options extends MatDialogConfig {
        private default: 'yes';
        type: Type;
        message: string;
        additional: string;
        title: string;
        buttons: Array<Button>;
        size: SizeSpec = RSDialog.Size.MEDIUM;
        cancelable: boolean;
        hasIcons: boolean;
        style: Style;
        component: any;
        html = false;
        values: object;
        close: (value?: any) => {};
        closeButton = true;
        closeOnNavigation = true;
        inputType: RSDialog.InputType; // TODO: ENUM
        inputValue: string | number;
        inputRegex: string; // TODO: CHECK
        inputPlaceholder: string;
        scrollAlwaysVisible = false;

        hasBackground: boolean = true;
        hasShadow: boolean = true;

        clearButtons() {
            this.buttons = new Array<Button>();
        }

        addButton(type: ButtonTypes);
        addButton(titleOrType: string | ButtonTypes, icon?: string, value?: any) {
            switch (titleOrType) {
                case ButtonTypes.CANCEL:
                    this.buttons.push(new Button('Cancel', 'chevron_left', defaultValues.CANCEL));
                    break;
                case ButtonTypes.NO:
                    this.buttons.push(new Button('No', 'close', defaultValues.NO));
                    break;
                case ButtonTypes.YES:
                    this.buttons.push(new Button('Yes', 'check', defaultValues.YES));
                    break;
                case ButtonTypes.OKAY:
                    this.buttons.push(new Button('Okay', 'thumb_up', defaultValues.YES));
                    break;
                default:
                    this.buttons.push(new Button(titleOrType, icon, value));
                    break;
            }
        }
        constructor(type?: Type, skipButtons?: boolean) {
            super();

            this.type = ( typeof type === 'undefined' ? Type.PROMPT : type );
            this.message = '';
            this.additional = '';
            this.html = false;
            this.size = Size.SMALL;
            this.hasIcons = false; // TODO: MAKE THIS A CONFIG SETTING
            this.style = Style.NORMAL;
            this.cancelable = (this.type !== Type.PROMPT);
            this.buttons = new Array<Button>();
            this.component = false;
            this.values = {};

            if (!skipButtons) {
                switch (type) {
                    case Type.PROMPT:
                        this.title = 'Message';
                        this.addButton(ButtonTypes.OKAY);
                        break;
                    case Type.INPUT:
                        this.title = 'Input';
                        if (this.cancelable) { this.addButton(ButtonTypes.CANCEL); }
                        this.addButton(ButtonTypes.OKAY);
                        break;
                    case Type.CONFIRM:
                        this.title = 'Confirm';
                        // if (this.cancelable) { this.addButton(ButtonTypes.CANCEL); }
                        this.addButton(ButtonTypes.NO);
                        this.addButton(ButtonTypes.YES);
                        break;
                }
            }
        }
    }
    // TODO: NOTE; HEIGHT IS NOT CURRENTLY USED
    export class SizeSpec {
        height: number | 'auto';
        width: number;
        type: string;
        getHeight() {
            return (this.height === 'auto' ? this.height : this.height + (this.type === 'v' ? 'vh' : this.type));
        }
        getWidth() {
            return this.width.toString() + (this.type === 'v' ? 'vw' : this.type);
        }
        constructor(height: number | 'auto', width: number, type: string = 'px') {
            this.height = (height ? height : 'auto');
            this.width = width;
            this.type = type;
        }
    }
    export class Size {
        static SMALL = new SizeSpec('auto', 360);
        static MEDIUM = new SizeSpec('auto', 560);
        static LARGE = new SizeSpec('auto',  1240);
    }
}
export namespace RSBottomSheet {
    export class Button {
        title: string;
        link?: string;
        note?: string;
        value?: any;
        constructor (title: string, value?: any, note?: string, link?: string) {
            this.title = title || 'Button';
            this.link = link || null;
            this.note = note || '';
            this.value = typeof value === 'undefined' ? 0 : value;
        }
    }
    export class Options {
        title: string;
        message: string;
        buttons: Array<Button>;
        cancelable: boolean;
        cancelValue: any;
        clearButtons () {
            this.buttons = new Array<Button>();
        }
        constructor() {
            this.title = '';
            this.message = '';
            this.cancelable = false;
            this.buttons = new Array<Button>();
            this.cancelValue = -1; // TODO: MAKE THIS GLOBAL
        }
    }
}
